import React, { useState } from 'react';
import { X, Send } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

const ContactForm = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    brand: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      // Send to backend API
      const response = await axios.post(`${API}/contact`, formData);
      
      toast.success("Thank you! We'll reach out from hello@aiadmitra.com soon.");
      
      // Reset form
      setFormData({
        name: '',
        email: '',
        brand: '',
        message: '',
      });
      
      onClose();
    } catch (error) {
      console.error('Form submission error:', error);
      toast.error('Failed to submit. Please try again or email us directly at hello@aiadmitra.com');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="contact-modal" onClick={onClose}>
      <div className="contact-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>
          <X size={28} />
        </button>
        
        <h2 className="contact-title">Let's Create a Film</h2>
        <p className="contact-subtitle">Tell us about your brand and vision</p>
        
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label htmlFor="name">Your Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="John Doe"
              disabled={isSubmitting}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="john@example.com"
              disabled={isSubmitting}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="brand">Brand / Company</label>
            <input
              type="text"
              id="brand"
              name="brand"
              value={formData.brand}
              onChange={handleChange}
              required
              placeholder="Your Brand Name"
              disabled={isSubmitting}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="message">Tell Us Your Story</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows="5"
              placeholder="What emotion do you want your audience to feel? What story do you want to tell?"
              disabled={isSubmitting}
            />
          </div>
          
          <button type="submit" className="submit-button" disabled={isSubmitting}>
            <Send size={18} />
            {isSubmitting ? 'Sending...' : 'Send Message'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
